<template>
    <div class="row">
        <div class="col">
            <span v-if="excessCalculationForGadget">
                <strong>Excess calculated:</strong> {{excessCalculationForGadget.dateCalculatedAsLocalTime}} - {{formatCurrency(excessCalculationForGadget.currencyCode, excessCalculationForGadget.excess)}}
            </span>
            <span v-else>
                <i class="fas fa-info-circle mr-2"></i>NO excess has been calculated for this gadget!
            </span>
            <br /><br />
                  <span v-if="excessPaymentForCalculation">
                      <strong>Excess paid:</strong> {{excessPaymentForCalculation.cardPaymentDateAsLocalTime}} - {{formatCurrency(excessPaymentForCalculation.cardPaymentCurrencyCode, excessPaymentForCalculation.cardPaymentAmount)}}
                  </span>
            <span v-else>
                <i class="fas fa-info-circle mr-2"></i>NO excess payment has been made for this gadget!
            </span>
        </div>
        <div v-if="userHasAccess && allowCalcExcess" class="col-3">
            <div class=" float-right">
                <button class="btn btn-primary btn-sm" @click="$bvModal.show(_uid + 're-calc-excess-modal')">Re-calculate</button>
                <b-modal :id="_uid + 're-calc-excess-modal'" hide-footer>
                    <template slot="modal-title">
                        Re-calculate excess
                    </template>
                    <div class="d-block text-center">
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label">
                                Calculation
                            </label>
                            <div class="col-sm-8">
                                <textarea class="form-control form-control-sm"
                                          placeholder="Calculation details"
                                          v-model="objEx.calculation">
                                </textarea>
                                <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="attemptSave && !getValidatorIsValid(objEx,'calculation')">
                                    {{getValidatorInvalidFeedback(objEx,'calculation')}}
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label">
                                Currency
                            </label>
                            <div class="col-sm-8">
                                <select v-model="objEx.currencyCode" class="form-control form-control-sm">
                                    <option>GBP</option>
                                    <option>EUR</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label">
                                Amount
                            </label>
                            <div class="col-sm-8">
                                <input type="text" class="form-control form-control-sm"
                                       placeholder="00.00" v-model="objEx.amount">
                                <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="attemptSave && !objEx.validators.find(v => v.item == 'amount').isValid">
                                    {{objEx.validators.find(v => v.item == 'amount').inValidFeedback}}
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label">
                                Reason
                            </label>
                            <div class="col-sm-8">
                                <textarea class="form-control form-control-sm"
                                          placeholder="Reason" v-model="objEx.reason">
                                </textarea>
                                <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="attemptSave && !objEx.validators.find(v => v.item == 'reason').isValid">
                                    {{objEx.validators.find(v => v.item == 'reason').inValidFeedback}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="float-right">
                                <button class="btn btn-danger mt-3" @click="handleCancelClick">Cancel</button>
                                <button class="btn btn-success mt-3 ml-2" @click="handleSaveClick">Save</button>
                            </div>
                        </div>
                    </div>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import { required, numeric, minLen } from '@/util/validators'
import { runValidators, getValidators, getValidatorsIsValid } from '@/util/validation'

import getSymbolFromCurrency from '@/util/currencySymbol.js'

import watchAll from '@/mixins/watchAll.js'
import validator from '@/mixins/validator.js'

let initObjEx = {
    calculation: null,
    amount: null,
    reason: null,
    currencyCode: 'GBP',
    validators: [
        {
            item: 'calculation',
            validators: [
                required,
                minLen(5)
            ],
            isValid: false,
            inValidFeedback: 'Required, MinLength 5'
        },
        {
            item: 'amount',
            validators: [
                required,
                numeric
            ],
            isValid: false,
            inValidFeedback: 'Required, Numeric'
        },
        {
            item: 'reason',
            validators: [
                required
            ],
            isValid: false,
            inValidFeedback: 'Required'
        }
    ]
}
import { mapActions } from 'vuex'

import authentication from '@/mixins/authentication.js'
import userRoles from '@/constants/userRoles.js'

export default {
  name: 'ClaimGadgetExcess',
        props: {
            claimId: { type: Number, required: true },
      gadgetId: { type : Number, required: true }
        },
        mixins: [
            watchAll,
            validator,
            authentication
        ],
  components: {
    
  },
 
  data: () => {
      return {

          objEx: Object.assign({}, initObjEx),          

          attemptSave: false
    }
  },
  computed: {
    selectedClaim() {
        return this.$store.getters.selectedClaim
    },
    excessCalculations() {
        return this.selectedClaim.excessCalculations
    },
      excessCalculationsForGadget() {
          if (this.excessCalculations) {
              return this.excessCalculations.filter(e => { return e.gadgetId == this.gadgetId; })
          }

          return null
    },
      excessCalculationForGadget() {
          if (this.excessCalculationsForGadget) {
              var mostRecentDate = new Date(Math.max.apply(null, this.excessCalculationsForGadget.map(e => {
                  return new Date(e.dateCalculated);
              })));
              var mostRecentObject = this.excessCalculationsForGadget.filter(e => {
                  var d = new Date(e.dateCalculated);
                  return d.getTime() == mostRecentDate.getTime();
              })[0];

              return mostRecentObject
          }
          return null
    },
    excessPayments() {
        return this.$store.getters.selectedClaim.excessPaymentDetails
    },
    excessPaymentForCalculation() {
        let calc = this.excessCalculationForGadget
        if (calc) {
            let { excessCalculationId } = calc
            return this.excessPayments.filter(p => { return p.excessCalculationId == excessCalculationId && p.cardPaymentStatusId == 1001 })[0]
        }
        return null
    },
    allowCalcExcess() {
        if (this.excessPaymentForCalculation) {
            return false
        }
        if (this.selectedClaim.approved == true) {
            return false
        }

        return true
    },
    userHasAccess() {
        return this.userHasRole(userRoles.CALC_EXCESS)
    }
},
  async mounted() {
      const response = await this.loadXsCalcsAndPayments()
      this.watchAll(['objEx.calculation', 'objEx.amount', 'objEx.reason'], this.objExRunValidators.bind(this));
  },
  watch: {
    
  },
methods: {
      ...mapActions([
          'addClaimManExcessCalc',
          'fetchExcessPaymentsClaim',
          'fetchExcessCalculationsClaim'
      ]),
      handleSaveClick() {
        this.attemptSave = true
        if (getValidatorsIsValid(this.objEx)) {
            this.$bvModal.hide(this._uid + 're-calc-excess-modal')

            let { claimId, gadgetId } = this
            let { calculation, amount, reason, currencyCode } = this.objEx

            let payload = {
                claimId,
                gadgetId,
                calculation,
                amount,
                currencyCode,
                reason
            }

            //console.log(JSON.stringify(fred))
            this.addClaimManExcessCalc(payload)

            this.objExReset()
            this.attemptSave = false
        }
    },
    handleCancelClick() {
        this.$bvModal.hide(this._uid + 're-calc-excess-modal')
        this.objExReset()
    },
    objExRunValidators() { runValidators(this.objEx) },
    objExReset() { this.objEx = Object.assign({}, initObjEx) },
      
    formatCurrency(currencyCode, amount) {
        if (typeof currencyCode !== 'string') return undefined
        if (typeof amount !== 'number') return undefined
        return getSymbolFromCurrency(currencyCode) + amount.toFixed(2)
    },
    async loadXsCalcsAndPayments() {

        try {
            let payload = {
                id: this.claimId,
                ignoreTaskFlag: true,
                pageSize: 10,
                pageNumber: 1,
                orderBy: "CardPaymentDate",
                sortDirection: "DESC"
            }
            const xsPayments = await this.fetchExcessPaymentsClaim(payload)
            const xsCalculations = await this.fetchExcessCalculationsClaim(this.claimId)

            return new Promise((resolve, reject) => {
                resolve({ xsCalculations: xsCalculations.data, xsPayments: xsPayments.data })
            })
        } catch (error) {
            console.log('loadXsCalcsAndPayments - error: ', error)
        }
    }
  }
}
</script>

